import React from 'react';
import elementwhite1 from '../../assets/images/element_white_1.webp';
import elementwhite2 from '../../assets/images/element_white_2.webp';
import blackgoogleplay from '../../assets/images/black_google_play.webp';
import blackappstore from '../../assets/images/black_appstore.webp';
import ourapp from '../../assets/images/our_app.webp';
import PlayStoreLink from './PlayStoreLink';
import AppStoreLink from './AppStoreLink';
import { siteCopy } from '../../content/siteCopy';

const Appdownload = () => {
  const { aboutUs } = siteCopy;

  return (
    <>
      <section className="row_am download_app">
        <div className="task_block" data-aos="fade-up" data-aos-duration={1500}>
          <div className="download_element elm1">
            <img src={elementwhite1} alt="" />
          </div>
          <div className="download_element elm2">
            <img src={elementwhite2} alt="" />
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="task_text">
                <div
                  className="section_title white_text"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                  data-aos-delay={100}
                >
                  <span className="title_badge">{aboutUs.download.badge}</span>
                  <h2>{aboutUs.download.title}</h2>
                  <p>{siteCopy.promo}</p>
                </div>
                <ul className="app_btn" data-aos="fade-up" data-aos-duration={1500}>
                  <li>
                    <PlayStoreLink>
                      <img className="blue_img" src={blackgoogleplay} alt="Get it on Google Play" />
                    </PlayStoreLink>
                  </li>
                  <li>
                    <AppStoreLink>
                      <img className="blue_img" src={blackappstore} alt="Download on the App Store" />
                    </AppStoreLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
                <div className="frame_img">
                  <img src={ourapp} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Appdownload;
